/**
 * Crée un DOM element a partir d'un array d'object
 * @param {object} data
 */
export function createAllBlock(data) {
    let html = "";
    $.each(data, function(index, object) {
        if (!object) {
            return;
        }
        if (object.type === "facebook") {
            html += createFacebookBlock(object);
        }

        if (object.type === "instagram") {
            html += createInstagramBlock(object);
        }
    });

    return $(html);
}

/** Crée le block facebook */
function createFacebookBlock(post) {
    let html = `<li>
                    <!-- Facebook -->
                    <a href="${post.url}" class="socialWall-item" target="_blank">
                        <div class="card card-lighter card-body">
                            <div class="row">
                                <div class="col-2 icone-facebook">
                                    <i class="fa fa-facebook"></i>
                                </div>
                                <div class="col-10">
                                    <div class="tag tag-sm text-primary">@${post.pageName}</div>
                                    <div class="tag tag-sm">${post.date}</div>
                                </div>
                            </div>

                            <p>
                                ${post.description}
                            </p>

                            <span class="label"><i class="fa fa-facebook"></i> Facebook</span>
                        </div>
                    </a>
                </li>`;
    return html;
}

/** Crée le block de Instagram */
function createInstagramBlock(post) {
    let html = `<li>
                <!-- Instagram -->
                <a href="${post.url}" class="socialWall-item" target="_blank">
                ${
                    post.img
                        ? `<figure class="socialWall-image">
                        <img src="${post.img}" alt="${post.type}" />
                    </figure>`
                        : ""
                }
                    <span class="label"><i class="fa fa-instagram"></i> Instagram</span>
                </a>
            </li>`;
    return html;
}

/** Masque le loader du DOM */
export function switchLoading() {
    $("#chargerPlusBlock").show();
    $("#chargement").removeClass("active");
}

/**
 * @param string text
 * @return string
 */
export function erreurBlock(text) {
    return `<div class="alert alert-warning" role="alert">
                ${text}
            </div>`;
}

/**
 * @param string text
 * @return string
 */
export function erreurBlockContainer(text) {
    return `<div class="container alert alert-warning" role="alert">
                ${text}
            </div>`;
}
